import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The most important writing lesson I learned in 6th grade maths class",
  "description": "",
  "published": "2013-06-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-most-important-writing-lesson-i-learned-in-6th-grade-maths-class/swizec/6237"],
  "categories": "Education, Mathematics, Student, Teacher, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/0H71ZANRNWT3G7eWWJId",
        "alt": "My elementary school",
        "title": "My elementary school"
      }}></img></p>
    <p><em parentName="p">{`"What is a square?"`}</em>{`, my maths teacher would ask.`}</p>
    <p><em parentName="p">{`"A square has four equal sides at right angles and its surface area is a`}{`*`}{`a"`}</em>{`, a pupil would answer. Happy they got all the facts right.`}</p>
    <p><em parentName="p">{`"But what `}<strong parentName="em">{`is`}</strong>{` a square? Those are just its properties."`}</em></p>
    <p><em parentName="p">{`"Errr ... a square is a ... shape? ... that has four equal sides at right angles?"`}</em></p>
    <p><em parentName="p">{`"That's right. A square is a shape, the rest are just properties."`}</em></p>
    <p>{`Every single one of us got that wrong. Every single time. Didn't matter if you were a straight A pupil or barely scraping by, everyone forgot to `}<em parentName="p">{`answer the question`}</em>{`.`}</p>
    <p>{`The story repeated itself a year later with geometric objects.`}</p>
    <p>{`If there's one important lesson about writing I ever learned, it's that `}<em parentName="p">{`a square is a shape`}</em>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=eef63233-86c9-48cf-8906-4153001d674e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      